import { modelOf } from "#src/models/modelOf.ts";
import { moment } from "#src/utils/dateTime.ts";
import {
  AdministratorTerm,
  CustomerTerm,
  EvaluationTerm,
  PrivateTerm,
  StaffTerm,
} from "#src/utils/terminology.ts";
import { currentOrganization, departments } from "#types/code-generator.ts";

type OrganizationData = currentOrganization["organization"];

export class OrganizationModel extends modelOf<OrganizationData>(
  () =>
    ({
      addDepartmentsDuringOnboarding: false,
      balanceAccounts: [],
      betaAccess: [],
      departments: [],
      description: "",
      events: [],
      integrations: [],
      requiredFields: [],
      tags: [],
      title: "",
    }) satisfies Partial<OrganizationData>
) {
  getUtcOffset() {
    let offset = 0;

    if (this.timezone) {
      const date = moment().tz(this.timezone);
      offset = date.utcOffset();
    }

    return offset;
  }

  getDepartment(id): departments["departments"][0] {
    return this.departments.find((d) => d.id === id);
  }

  get hasDepartments() {
    return this.departments.length > 1;
  }

  get defaultDepartment() {
    return this.departments.find((d) => d.default);
  }

  get privateTerminology() {
    return this.terminology?.private || PrivateTerm["Private Lesson"];
  }

  get evaluationTerminology() {
    return this.terminology?.evaluation || EvaluationTerm.Evaluation;
  }

  get administratorTerminology() {
    return this.terminology?.administrator || AdministratorTerm.Administrator;
  }

  get staffTerminology() {
    return this.terminology?.staff || StaffTerm.Staff;
  }

  get customerTerminology() {
    return this.terminology?.customer || CustomerTerm.Customer;
  }
}

export default OrganizationModel;
